import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { StyledXMLNews } from "../../../styled/xml";

const XmlNewsDialog = ({ open, onClose, xmlData, loading }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>Visualizar XML</DialogTitle>
            <DialogContent>
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <StyledXMLNews.XmlVisualizer >
                        {xmlData && xmlData.documentoXml ? xmlData.documentoXml : 'No hay datos XML para mostrar.'}
                    </StyledXMLNews.XmlVisualizer>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default XmlNewsDialog;
